import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import './chartWaste.css';
import Content01 from "./srilanka_content_01";
import Content02 from './srilanka_content_02';
import Content03 from './srilanka_content_03';
import Content04 from './srilanka_content_04';

export default function Chart() {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <ScrollTrigger
      onEnter={() => setCounterOn(true)}
      onExit={() => setCounterOn(false)}
    >
      <div style={{ position: "relative" }}>
        <div className="chart-box-ban">
          <div className="conserve-waste-chart-02-card-container">
            <div className="conserve-waste-chart-02-card">
              <center>
                <div className="conserve-waste-chart-02-number number-content-01">
                  {counterOn && (<CountUp start={0} end={46.21} decimals={2} duration={3} delay={0.3} />)}%
                </div>
                <div>
                  <Content01 />
                </div>
                <div className="conserve-waste-chart-02-letter letter-content-01">
                  <h4>2019</h4>
                </div>
              </center>
            </div>

            <div className="conserve-waste-chart-02-card">
              <center>
                <div className="conserve-waste-chart-02-number number-content-02">
                  {counterOn && (<CountUp start={0} end={41.23} decimals={2} duration={3} delay={0.3} />)}%
                </div>
                <div>
                  <Content02 />
                </div>
                <div className="conserve-waste-chart-02-letter letter-content-02">
                  <h4>2021</h4>
                </div>
              </center>
            </div>
            
            <div className="conserve-waste-chart-02-card">
              <center>
                <div className="conserve-waste-chart-02-number number-content-03">
                  {counterOn && (<CountUp start={0} end={6.99} decimals={2} duration={3} delay={0.3} />)}%
                </div>
                <div>
                  <Content03 />
                </div>
                <div className="conserve-waste-chart-02-letter letter-content-03">
                  <h4>2022</h4>
                </div>
              </center>
            </div>

            <div className="conserve-waste-chart-02-card">
              <center>
                <div className="conserve-waste-chart-02-number number-content-04">
                  {counterOn && (<CountUp start={0} end={6.41} decimals={2} duration={3} delay={0.3} />)}%
                </div>
                <div>
                  <Content04 />
                </div>
                <div className="conserve-waste-chart-02-letter letter-content-04">
                  <h4>2023</h4>
                </div>
              </center>
            </div>

          </div>
        </div>
      </div>
    </ScrollTrigger>
  );
}
